/** Attribute filter options — single source of truth used by AppHeader, ViewBuilder, filtering logic */
export const ATTR_FILTER_OPTIONS = [
  { value: "attr_season",         label: "Сезон",          ids: ["9725", "4495"] },
  { value: "attr_gender",         label: "Пол",            ids: ["9163"] },
  { value: "attr_brand",          label: "Бренд",          ids: ["85", "31"] },
  { value: "type_name",           label: "Тип товара",     ids: [] },
  { value: "attr_color",          label: "Цвет",           ids: ["10096"] },
  { value: "attr_custom_color",   label: "Свой цвет",      ids: ["10097"] },
  { value: "attr_size",           label: "Размер",         ids: ["4298", "5326", "9533", "4295"] },
  { value: "attr_material",       label: "Материал",       ids: ["10550", "22385"] },
  { value: "attr_common_article", label: "Общий артикул",  ids: ["8292", "9024"] },
] as const;

export type AttrFilterOption = typeof ATTR_FILTER_OPTIONS[number];

/** Fast lookup: attr_key → ozon attribute ids */
export const ATTR_IDS: Record<string, string[]> = Object.fromEntries(
  ATTR_FILTER_OPTIONS.map(o => [o.value, [...o.ids]])
);

/** Numeric filter options — used in AppHeader and ViewBuilder */
export const NUMERIC_FILTER_OPTIONS = [
  { value: "stock",        label: "Остаток" },
  { value: "orders_7d",    label: "Заказы 7д" },
  { value: "orders_14d",   label: "Заказы 14д" },
  { value: "orders_30d",   label: "Заказы 30д" },
  { value: "orders_speed", label: "Скорость заказа 7д" },
  { value: "orders_speed_14d", label: "Скорость заказа 14д" },
  { value: "orders_speed_30d", label: "Скорость заказа 30д" },
  { value: "price",        label: "Цена" },
  { value: "revenue",      label: "Выручка" },
  { value: "idc",          label: "Дней до 0" },
  { value: "hits_view",    label: "Показы" },
  { value: "conv_tocart",  label: "Конверсия %" },
  { value: "ad_drr",       label: "ДРР%" },
  { value: "ad_spend",     label: "Расходы реклама" },
] as const;

export type NumericFilterOption = typeof NUMERIC_FILTER_OPTIONS[number];

/** Specific attr ID sets used for grouping */
export const COMMON_ARTICLE_IDS = ["8292", "9024"] as const;
export const COLOR_IDS          = ["10097", "10096"] as const;
export const SIZE_IDS           = ["4298", "5326", "9533", "4295"] as const;
